import { createFileRoute } from '@tanstack/react-router'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronRight } from '@fortawesome/free-solid-svg-icons'
import { Footer, HeaderMiddle, Navbar, TopBar } from '../components/SiteChrome'
import { WhatsAppChannelSection } from '../components/WhatsAppChannelSection'
import { getStorefrontConfig } from '../lib/dropify'
import { DEFAULT_OG_IMAGE, absoluteUrl } from '../lib/seo'

export const Route = createFileRoute('/syarat-ketentuan')({
  loader: async () => ({
    config: await getStorefrontConfig().catch(() => null),
  }),
  head: () => ({
    meta: [
      { title: 'Syarat & Ketentuan Layanan | Dropify Grosir' },
      { name: 'description', content: 'Syarat dan ketentuan penggunaan website serta transaksi grosir dengan Dropify, distributor tangan pertama di Indonesia. Mohon dibaca sebelum memesan.' },
      { property: 'og:title', content: 'Syarat & Ketentuan Layanan | Dropify Grosir' },
      { property: 'og:description', content: 'Syarat dan ketentuan penggunaan website serta transaksi grosir dengan Dropify, distributor tangan pertama di Indonesia. Mohon dibaca sebelum memesan.' },
      { property: 'og:url', content: absoluteUrl('/syarat-ketentuan') },
      { property: 'og:image', content: DEFAULT_OG_IMAGE },
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:title', content: 'Syarat & Ketentuan Layanan | Dropify Grosir' },
      { name: 'twitter:description', content: 'Syarat dan ketentuan penggunaan website serta transaksi grosir dengan Dropify, distributor tangan pertama di Indonesia. Mohon dibaca sebelum memesan.' },
      { name: 'twitter:image', content: DEFAULT_OG_IMAGE },
    ],
    links: [
      { rel: 'canonical', href: absoluteUrl('/syarat-ketentuan') },
    ],
  }),
  component: SyaratKetentuanPage,
})

function SyaratKetentuanPage() {
  const { config } = Route.useLoaderData()

  return (
    <div className="min-h-screen bg-slate-50">
      <TopBar config={config} />
      <HeaderMiddle />
      <Navbar />

      <div className="bg-slate-900 py-14">
        <div className="max-w-7xl mx-auto px-4">
          <nav className="flex items-center gap-1.5 text-xs text-slate-400 mb-4">
            <a href="/" className="hover:text-white transition-colors">Beranda</a>
            <FontAwesomeIcon icon={faChevronRight} className="w-3 h-3" />
            <span className="text-white font-medium">Syarat & Ketentuan</span>
          </nav>
          <h1 className="text-4xl font-black text-white uppercase tracking-tight mb-2">Syarat & Ketentuan</h1>
          <p className="text-slate-300 text-sm max-w-2xl">
            Ketentuan dasar yang berlaku untuk penggunaan website, komunikasi, dan proses transaksi dengan Dropify.
          </p>
        </div>
      </div>

      <WhatsAppChannelSection />

      <main className="max-w-4xl mx-auto px-4 py-12">
        <div className="bg-white rounded-2xl border border-slate-100 p-8 md:p-10 space-y-8">
          <section>
            <h2 className="text-xl font-black text-slate-900 uppercase tracking-tight mb-3">1. Informasi Produk</h2>
            <p className="text-sm text-slate-600 leading-relaxed">
              Kami berusaha menampilkan informasi produk seakurat mungkin. Namun, ketersediaan stok, detail varian, dan harga dapat berubah sewaktu-waktu sesuai pembaruan dari tim admin.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-black text-slate-900 uppercase tracking-tight mb-3">2. Konfirmasi Pesanan</h2>
            <p className="text-sm text-slate-600 leading-relaxed">
              Pemesanan dilakukan melalui WhatsApp resmi Dropify. Website dan akun media sosial resmi digunakan untuk menyampaikan informasi serta mengarahkan pembeli ke WhatsApp. Pesanan mulai diproses setelah admin mengonfirmasi rincian barang, jumlah, pembayaran, dan alamat pengiriman.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-black text-slate-900 uppercase tracking-tight mb-3">3. Penggunaan Konten</h2>
            <p className="text-sm text-slate-600 leading-relaxed">
              Materi visual dan informasi produk pada website ini digunakan untuk kebutuhan promosi dan penjualan produk Dropify. Penggunaan ulang untuk tujuan yang menyesatkan atau merugikan pihak lain tidak diperkenankan.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-black text-slate-900 uppercase tracking-tight mb-3">4. Perubahan Ketentuan</h2>
            <p className="text-sm text-slate-600 leading-relaxed">
              Dropify berhak memperbarui syarat dan ketentuan ini sewaktu-waktu tanpa pemberitahuan terpisah. Versi yang tampil pada halaman ini menjadi acuan yang berlaku.
            </p>
          </section>
        </div>
      </main>

      <Footer config={config} />
    </div>
  )
}
